/* tslint:disable */
/* eslint-disable */
/**
 * crm-screener
 * crm-screener
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface LeadCareAttributesInner
 */
export interface LeadCareAttributesInner {
    /**
     * 
     * @type {string}
     * @memberof LeadCareAttributesInner
     */
    id: string;
    /**
     * 
     * @type {string}
     * @memberof LeadCareAttributesInner
     */
    lead_id: string;
    /**
     * 
     * @type {string}
     * @memberof LeadCareAttributesInner
     */
    care_attribute_id: string;
    /**
     * 
     * @type {string}
     * @memberof LeadCareAttributesInner
     */
    category: LeadCareAttributesInnerCategoryEnum;
    /**
     * 
     * @type {string}
     * @memberof LeadCareAttributesInner
     */
    label: string;
    /**
     * 
     * @type {string}
     * @memberof LeadCareAttributesInner
     */
    created_by_user_id: string;
    /**
     * 
     * @type {string}
     * @memberof LeadCareAttributesInner
     */
    created_at: string;
}


/**
 * @export
 */
export const LeadCareAttributesInnerCategoryEnum = {
    ClinicalCareNeed: 'clinical_care_need',
    Program: 'program',
    TypeOfCare: 'type_of_care'
} as const;
export type LeadCareAttributesInnerCategoryEnum = typeof LeadCareAttributesInnerCategoryEnum[keyof typeof LeadCareAttributesInnerCategoryEnum];


/**
 * Check if a given object implements the LeadCareAttributesInner interface.
 */
export function instanceOfLeadCareAttributesInner(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "id" in value;
    isInstance = isInstance && "lead_id" in value;
    isInstance = isInstance && "care_attribute_id" in value;
    isInstance = isInstance && "category" in value;
    isInstance = isInstance && "label" in value;
    isInstance = isInstance && "created_by_user_id" in value;
    isInstance = isInstance && "created_at" in value;

    return isInstance;
}

export function LeadCareAttributesInnerFromJSON(json: any): LeadCareAttributesInner {
    return LeadCareAttributesInnerFromJSONTyped(json, false);
}

export function LeadCareAttributesInnerFromJSONTyped(json: any, ignoreDiscriminator: boolean): LeadCareAttributesInner {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'id': json['id'],
        'lead_id': json['lead_id'],
        'care_attribute_id': json['care_attribute_id'],
        'category': json['category'],
        'label': json['label'],
        'created_by_user_id': json['created_by_user_id'],
        'created_at': json['created_at'],
    };
}

export function LeadCareAttributesInnerToJSON(value?: LeadCareAttributesInner | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'id': value.id,
        'lead_id': value.lead_id,
        'care_attribute_id': value.care_attribute_id,
        'category': value.category,
        'label': value.label,
        'created_by_user_id': value.created_by_user_id,
        'created_at': value.created_at,
    };
}

